import React from 'react';
import useUiuxStore from 'src/store/useUiuxStore';

export interface ConfirmModalProps {
    title?: string;
    message: string;
	onConfirm: () => void;
	onCancel?: () => void;
	confirmText?: string;
	cancelText?: string;
}

export const defaultConfirmModalProps: ConfirmModalProps = {
    title: "알림",
    message: "",
	onConfirm: () => {}
}

const ConfirmModal: React.FC = () => {


	const { setConfirmModalVisible, confirmModalProps } = useUiuxStore();

	if (!confirmModalProps) return null;

	const { title, message, onConfirm, onCancel, confirmText = '확인', cancelText = '취소' } = confirmModalProps;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
            <div className="bg-white border-2 border-blue-500 rounded-lg shadow-lg p-6 w-[400px] max-w-[90%] transform transition-all">
                
                <div className="flex items-center mb-4">
                    <div className="text-blue-500 mr-2">
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900">{title}</h3>
                </div>

                <div className="mb-6">
                    <p className="text-gray-600 whitespace-pre-wrap text-sm leading-relaxed">
                        {message}
                    </p>
                </div>


                <div className="flex justify-end gap-2">
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-blue-500 text-white text-sm font-medium rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                    >
                        {confirmText}
                    </button>
                    {onCancel && (
                        <button
                            onClick={onCancel}
                            className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors"
                        >
                            {cancelText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;